import { createElement } from 'react';
import { PromptCardRedesign } from '@ai-platform/utils';

import { useExperimentFlag } from '../../contexts';
import { ScreenSize, useGetScreenSize } from '../../hooks';
import { PromptCardNewMobileSkeleton } from '../PromptCard/experiments/new';

import { PromptCardSkeletonProps } from './PromptCardSkeleton.types';
import { PromptCardSkeleton as PromptCardSkeletonBase } from './PromptCardSkeleton';

export type { PromptCardSkeletonProps } from './PromptCardSkeleton.types';

export const PromptCardSkeleton = (props: PromptCardSkeletonProps) => {
    const { size, fromFeed } = props;

    const experimentFlag = useExperimentFlag('promptCardRedesign');
    const screenSize = useGetScreenSize();

    const isMobile = screenSize === ScreenSize.Mobile;
    const isNewMobileDesign = isMobile && fromFeed && size !== 'small';

    if (experimentFlag === PromptCardRedesign.New && isNewMobileDesign) {
        // Включаем новый дизайн скелетонов только на главной ленте и в подборках
        return createElement(PromptCardNewMobileSkeleton, props);
    }

    return createElement(PromptCardSkeletonBase, props);
};
